import { useEffect } from 'react';
import { Toaster } from './components/ui/sonner';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ProjectHighlights from './components/ProjectHighlights';
import FloorPlansSection from './components/FloorPlansSection';
import ElevationsSection from './components/ElevationsSection';
import CustomerReviewsSection from './components/CustomerReviewsSection';
import LocationSection from './components/LocationSection';
import PartnersSection from './components/PartnersSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Smooth scrolling for the entire page
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Cleanup function
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Toast notifications */}
      <Toaster 
        position="top-right"
        toastOptions={{
          style: {
            background: 'white',
            color: '#1f2937',
            border: '1px solid #e5e7eb'
          }
        }}
      />
      
      {/* Navigation */}
      <Navigation />
      
      {/* Main Content */}
      <main>
        {/* Hero Section */}
        <HeroSection />
        
        {/* Project Highlights */}
        <ProjectHighlights />
        
        {/* Elevations */}
        <ElevationsSection />
        
        {/* Floor Plans */}
        <FloorPlansSection />
        
        {/* Customer Reviews */}
        <CustomerReviewsSection />
        
        {/* Location */}
        <LocationSection />
        
        {/* Partners */}
        <PartnersSection />
        
        {/* Contact */}
        <ContactSection />
      </main>
      
      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;